import React, { useEffect } from 'react';
const PIXEL_IDS = ['1332996085607751', '1359892025602260'];

/**
 * Meta Pixel base code (official Meta snippet), injected once as early as
 * possible on load. Inserts the <script> into <head> and the <noscript>
 * fallbacks into <body>. One `fbq('init', ...)` per pixel ID, then a single
 * PageView which fires for every initialized pixel.
 *
 * NOTE: Magic Patterns has no editable index.html <head>, so the exact
 * official snippet is injected at runtime instead — pixel IDs and script
 * structure are kept verbatim.
 */
export function MetaPixel() {
  useEffect(() => {
    // Guard: ensure it only ever runs / injects once per page session.
    if (typeof window === 'undefined') return;
    if ((window as any).__metaPixelInjected) return;
    (window as any).__metaPixelInjected = true;
    const inits = PIXEL_IDS.map(id => `fbq('init', '${id}');`).join('\n');

    // --- Meta Pixel Code (script) ---
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
${inits}
fbq('track', 'PageView');`;
    document.head.appendChild(script);

    // --- Meta Pixel Code (noscript fallback, one per pixel) ---
    PIXEL_IDS.forEach(id => {
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    });
  }, []);
  return null;
}